module.exports = __webpack_public_path__ + "static/img/circle.495f503a.svg";